<label class="soft-label top" [class.required]="control()?.required">
  {{ control()?.title | translate }}
</label>
